export default "__VITE_ASSET__Bf$c$o8n__"